module.exports = __webpack_public_path__ + "static/media/closeIconInvoice.c5b1db82.svg";